module.exports = __webpack_public_path__ + "static/media/wicketLock.403a0a2b.jpg";